module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "box box-info"
  }, [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('label', {
    attrs: {
      "for": "fromDate"
    }
  }, [_vm._v("Delivery Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryCode),
      expression: "deliveryCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "orderNo"
    },
    domProps: {
      "value": (_vm.deliveryCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.deliveryCode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-1 p-mt-5"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded",
    attrs: {
      "label": "Search",
      "type": "submit",
      "lable": "Search"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchDelivery.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12"
  }, [(this.deliveryRemarksLogLists.length > 0) ? _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exportCSV()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "float": "right",
      "height": "3em",
      "width": "3em"
    },
    attrs: {
      "src": require("../../../../static/img/excel.png")
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('DataTable', {
    ref: "dt",
    staticClass: "p-datatable-gridlines",
    attrs: {
      "value": _vm.deliveryRemarksLogLists,
      "dataKey": "id",
      "paginator": true,
      "rows": 10,
      "filters": _vm.filters
    }
  }, [_c('Column', {
    attrs: {
      "header": "Delivery Code",
      "sortable": true,
      "field": "deliveryCode",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['deliveryCode']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'deliveryCode', $$v)
            },
            expression: "filters['deliveryCode']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Status",
      "sortable": true,
      "field": "status",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['status']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'status', $$v)
            },
            expression: "filters['status']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Remarks",
      "sortable": true,
      "field": "remarks",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['remarks']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'remarks', $$v)
            },
            expression: "filters['remarks']"
          }
        })]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "User",
      "sortable": true,
      "field": "userName",
      "filterMatchMode": "contains"
    },
    scopedSlots: _vm._u([{
      key: "filter",
      fn: function() {
        return [_c('InputText', {
          staticClass: "p-column-filter",
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.filters['userName']),
            callback: function($$v) {
              _vm.$set(_vm.filters, 'userName', $$v)
            },
            expression: "filters['userName']"
          }
        })]
      },
      proxy: true
    }])
  })], 1)], 1)]), _vm._v(" "), _c('Dialog', {
    on: {
      "cancel": _vm.cancel,
      "deleted": _vm.deleteReport
    },
    model: {
      value: (_vm.dialogShow),
      callback: function($$v) {
        _vm.dialogShow = $$v
      },
      expression: "dialogShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-769f23f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/delivery/deliveryRemarksLogReport.vue
// module id = 2324
// module chunks = 0